const slugify = (value) => {
  return value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");
};
const courses = [
  {
    id: 1,
    title: "Megapack de minas",
    shortDescription:
      "Paquete premium para minería con procesos y operación en alto rendimiento.",
    longDescription:
      "Programa integral para profesionales y equipos de minería que buscan estandarizar procesos, mejorar seguridad y elevar productividad.\n\nIncluye guías prácticas, plantillas y casos de uso para aplicar en operaciones reales.",
    price: 10,
    originalPrice: 45,
    category: "Paquete",
    image:
      "https://images.pexels.com/photos/2101137/pexels-photo-2101137.jpeg?auto=compress&cs=tinysrgb&w=800",
    rating: { rate: 4.9, count: 180 },
  },
  {
    id: 2,
    title: "Automatización con n8n",
    shortDescription:
      "Crea agentes de WhatsApp y automatiza ventas con flujos inteligentes.",
    longDescription:
      "Creación de Agentes IA para WhatsApp con N8N.\n\nTemario:\n- Introducción a la Automatización y Creación de Agentes Básicos\nLos estudiantes aprenderán a crear su primer agente de WhatsApp que capture leads y automatice respuestas, identificando cuellos de botella en sus procesos de ventas.\n- Automatización Avanzada para Prospectos y Calificación de Leads (Parte 1)\nDesarrollo de un agente avanzado que investigue prospectos antes de iniciar la comunicación y creación de un sistema de calificación automática de leads según criterios definidos.\n- Automatización Avanzada para Prospectos y Calificación de Leads (Parte 2)\nContinuación del desarrollo del agente avanzado con investigación de prospectos y calificación automática de leads.\n- Automatización Avanzada para Prospectos y Calificación de Leads (Parte 3)\nProfundización en la automatización avanzada, perfeccionando el sistema de calificación automática de leads.\n- Contacto Automatizado e Integración con CRM\nIntegración de agentes con un CRM para gestionar conversaciones, realizar seguimientos y automatizar todo el ciclo de captación y contacto con leads, optimizando la productividad.",
    price: 10,
    originalPrice: 45,
    category: "Automatización",
    image:
      "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=800",
    rating: { rate: 4.8, count: 140 },
  },
  {
    id: 3,
    title: "Análisis y diseño estructural de puentes en ingeniería civil",
    shortDescription:
      "Modela y dimensiona puentes con criterios estructurales actuales.",
    longDescription:
      "CURSO PREMIUM: ANÁLISIS Y DISEÑO DE PUENTES + CERTIFICADO QR-WEB\n\n¿Qué incluye el curso completo?\n- Fundamentos del puente\n- Concepto de puente\n- Información básica\n- Materiales y comportamiento\n- Concreto reforzado\n- Confinamiento\n- Performance de zonas\n- Parámetros de diseño\n- Modificadores de factores\n- Longitud de rótula plástica\n- Tipos de puentes\n- Puentes rectos de concreto\n- Puente arco\n- Puente atirantado\n- CSIBridge paso a paso\n- Curso en CSIBridge\n- Modelado paso a paso\n- Contenido ampliado\n- Y más\n\nBeneficios del curso\n- Certificado QR-WEB\n- Acceso inmediato al contenido\n- Enfoque técnico estructural\n- Aplicable a proyectos reales\n- Ideal para estudiantes y técnicos\n\nBonos especiales para hoy\n- Material de apoyo técnico\n- Guías prácticas de modelado\n- Entrega por google drive\n\nPromoción exclusiva",
    price: 10,
    originalPrice: 45,
    category: "Ingeniería civil",
    image: "/assets/puentes.jpg",
    rating: { rate: 4.9, count: 95 },
  },
  {
    id: 4,
    title: "Diseño digital, modelado y fabricación mediante impresión 3D",
    shortDescription:
      "Del modelado al prototipado y fabricación con impresión 3D.",
    longDescription:
      "CURSO PREMIUM: DISEÑO E IMPRESIÓN 3D + CERTIFICADO QR-WEB\n\n¿Qué incluye el curso completo?\n- Introducción al mundo 3D\n- Diseño e impresión 3D\n- Historia y evolución\n- Usos y aplicaciones\n- Conceptos fundamentales\n- Diseño tridimensional\n- Espacio y formas\n- Flujo de trabajo 3D\n- Herramientas de diseño\n- Creación básica de objetos\n- Buenas prácticas digitales\n- Preparación para impresión\n- Diseño a objeto físico\n- Parámetros de impresión\n- Evitar errores comunes\n- Materiales y usos\n- Materiales de impresión 3D\n- Ventajas y limitaciones\n- Selección por proyecto\n- Proceso de impresión\n- Etapas de impresión 3D\n- Calidad de la pieza\n- Mantenimiento básico\n- Postprocesado\n- Acabados estéticos\n- Ensamblaje y personalización\n- Aplicaciones prácticas\n- Aplicaciones y proyectos\n- Objetos útiles y creativos\n- Proyecto guiado paso a paso\n- Ideas de aplicación\n- Entrega por google drive\n\nPromoción exclusiva",
    price: 10,
    originalPrice: 45,
    category: "Diseño digital",
    image: "/assets/3d.jpg",
    rating: { rate: 4.7, count: 120 },
  },
  {
    id: 5,
    title: "Diseño, cálculo y construcción de domos geodésicos",
    shortDescription:
      "Diseña y construye domos geodésicos con precisión estructural.",
    longDescription:
      "Programa práctico para calcular, diseñar y construir domos geodésicos.\n\nIncluye:\n- Principios estructurales.\n- Cálculo de piezas y uniones.\n- Guías de montaje en obra.",
    price: 10,
    originalPrice: 45,
    category: "Ingeniería civil",
    image: "/assets/domos.jpg",
    rating: { rate: 4.8, count: 110 },
  },
  {
    id: 6,
    title: "Control de calidad, ensayos y análisis del concreto",
    shortDescription:
      "Ensayos y control de calidad para concreto estructural confiable.",
    longDescription:
      "Curso técnico para ejecutar y analizar ensayos de concreto.\n\nIncluye:\n- Muestreo y ensayos estándar.\n- Criterios de aceptación y control.\n- Reportes y mejora continua.",
    price: 10,
    originalPrice: 45,
    category: "Ingeniería civil",
    image: "/assets/concreto.jpg",
    rating: { rate: 4.8, count: 130 },
  },
  {
    id: 7,
    title: "Análisis y diseño estructural de escaleras en edificaciones",
    shortDescription:
      "Diseño estructural de escaleras seguras y eficientes.",
    longDescription:
      "Curso especializado en cálculo y diseño de escaleras.\n\nIncluye:\n- Tipologías y criterios de diseño.\n- Cargas, refuerzos y detalles.\n- Recomendaciones constructivas.",
    price: 10,
    originalPrice: 45,
    category: "Ingeniería civil",
    image:
      "https://images.pexels.com/photos/323705/pexels-photo-323705.jpeg?auto=compress&cs=tinysrgb&w=800",
    rating: { rate: 4.7, count: 85 },
  },
  {
    id: 8,
    title: "Masterclass en AutoCAD: diseños en 2D, 3D y planos",
    shortDescription:
      "Domina AutoCAD para diseños 2D, 3D y planos profesionales.",
    longDescription:
      "Masterclass completa para acelerar tu dominio de AutoCAD.\n\nIncluye:\n- Herramientas esenciales y atajos.\n- Modelado 2D/3D y capas.\n- Entrega de planos listos para obra.",
    price: 10,
    originalPrice: 45,
    category: "CAD",
    image: "/assets/autocad.jpg",
    rating: { rate: 4.9, count: 160 },
  },
  {
    id: 9,
    title: "Pack de cursos de Topografía y Geodesia",
    shortDescription:
      "Pack premium con más de 150 cursos, diplomados y talleres de topografía y geodesia.",
    longDescription: `👷‍♂️🚧EL MEJOR PACK DE CURSOS DE TOPOGRAFÍA Y GEODESIA👷‍♂️🚧
Un compilado de Diplomados, Cursos y Talleres de las mejores academias, donde aprenderás a utilizar toda las herramientas, procedimientos, el conocimiento y todo lo necesario para poder realizar un correcto Estudio de Topografía y Geodesia.

🔰 CONTENIDO DE LOS CURSOS🔰
✔️Videos grabados de Mentorías de pago.
✔️Material didáctico proporcionado por cada mentor.
✔Instaladores
✔Plantillas Editables
➖➖➖➖➖➖
👇 PARA MAYOR INFORMACION escríbenos 
➖➖➖➖➖➖
🔴CONTENIDO:
💻MAS DE 150 CURSOS:
✅1.CURSO TOPODECIA - EXPERTO EN CIVIL 3D
✅2.CURSO TOPOGRAFIA APLICADA A EJECUCION DE OBRAS
✅3.CURSO TOPOGRAFÍA APLICADA A LA MINERIA SUBTERRANEA
✅4.CURSO TOPOGRAFIA APLICADA A LINEAS DE TRANSMISION
✅5.CURSO TOPOGRAFIA APLICADA A NIVELACION DE REDES DE ALCANTARILLADO
✅6.CURSO TOPOGRAFIA APLICADA A PROYECTOS DE INGENIERIA 1
✅7.CURSO TOPOGRAFÍA APLICADA EN OBRAS DE SANEAMIENTO DE AGUA Y ALCANTARILLADO
✅8.CURSO TOPOGRAFÍA APLICADA PARA CARRETERAS
✅9.CURSO TOPOGRAFÍA APLICADO A LINEAS DE TRANSMISION
✅10.CURSO TOPOGRAFIA APLICADO A PROYECTOS DE INGENIERIA
✅11.CURSO TOPOGRAFIA APLICADO AL TRAZO Y REPLANTEO DE OBRAS CIVILES
✅12.CURSO TOPOGRAFIA CON DRONES
✅13.CURSO TOPOGRAFIA CON DRONES
✅14.CURSO TOPOGRAFIA DIGITAL APLICADA
✅15.CURSO TOPOGRAFIA PARA LA SUPERVICION DE OBRAS
✅16.CURSO TOPOGRAFIA Y FOTOGRAMETRIA CON DRONES Y USO DE RTK
✅17.CURSO TRANSFORMACION DE COORDENADAS UTM A TOPOGRAFICAS
✅18.CURSO UNIVERSO INGENIEROS-LOTIZACION CON CIVIL 3D
✅19.CURSO ACTUALIZACION TOPOGRAFICA SUBTERRANEA 3D Y LEVANTAMIENTO DE LABORES ANTIGUAS.
✅20.CURSO AJUSTE DE POLIGONALES TOPOGRAFICAS
✅21.CURSO AJUSTE DE POLIGONALES TOPOGRAFICAS 1D-2D-3D
✅22.CURSO AJUSTES DE POLIGONALES TOPOGRAFICAS
✅23.CURSO AJUSTES LOCALES UTM -TOPOGRAFICA
✅24.CURSO AJUSTES POR MINIMOS CUADRADOS Y POLIGONALES EN OBRAS VIALES
✅25.CURSO ANÁLISIS DE PELIGROS POR DESLIZAMIENTOS CON QGIS
✅26.CURSO ANÁLISIS DE REDES CON ARCGIS
✅27.CURSO ANÁLISIS ESPACIAL Y DISEÑO CARTOGRÁFICO CON ARCGIS PRO
✅28.CURSO ARCGIS APLICADO A ESTUDIOS DE IMPACTO AMBIENTAL
✅29.CURSO ARCGIS APLICADO AL ANALISIS DE REDES TRANSPORTE
✅30.CURSO ARCGIS APLICADO AL CATASTRO
✅31.CURSO ARCGIS COMPLETO - ASUL GIS
✅32.CURSO ARCGIS PARA ECOLOGIA
✅33.CURSO ARCGIS PARA GESTION DE RIESGOS
✅34.CURSO ARCGIS PARA MEDIO AMBIENTE
✅35.CURSO ARCGIS PARA TELEDETECCION
✅36.CURSO ARCGIS PRO
✅37.CURSO ARCGIS Y DRONES PARA CATASTRO
✅38.CURSO AUTODESK- CERTIFICACIÓN DE PUNTOS DE ORDEN C ANTE EL IGN
✅39.CURSO CAD-AJUSTES DE POLIGONALES TOPOGRAFICAS
✅40.CURSO CARTOGRAFIA APLICADA A GNSS
✅41.CURSO CARTOGRAFIA APLICADA A RECEPETORES GNSS
✅42.CURSO CIVIL 3D APICADO A LA HIDRAULICA
✅43.CURSO CIVIL 3D APLICADA A LA TOPOGRAFIA
✅44.CURSO CIVIL 3D APLICADO A PROYECTOS MINEROS
✅45.CURSO CIVIL 3D APLICADO AL DISEÑO DE CANALES
✅46.CURSO COMPLETO ARCGIS PRO PARA TOPOGRAFIA
✅47.CURSO CONTROL TOPOGRÁFICO PARA ALCANTARILLADO, PISTAS Y VEREDAS
✅48.CURSO CREAR PLANO TOPOGRAFICO CON CIVIL 3D
✅49.CURSO CURSO AVANZADO DE SISTEMA DE INFORMACION GEOGRAFICA
✅50.CURSO DE ALTA ESPECIALIZACION INTERMEDIO Y AVANZADO
✅51.CURSO DE CATASTRO
✅52.CURSO DE DRONES APLICADO A LA TOPOGRAFIA
✅53.CURSO DE DRONES DESDE CERO
✅54.CURSO DE ESTACION TOTAL
✅55.CURSO DE ESTACION TOTAL Y NIVEL DE INGENIERO
✅56.CURSO DE FOTOGRAMETRÍA CON DRONES APLICADO A MINERÍA
✅57.CURSO DE TOPOGRAFIA
✅58.CURSO DESARROLLO, ANÁLISIS Y AJUSTE DE POLIGONALES TOPOGRÁFICAS
✅59.CURSO DISEÑO DE INFRAESTRUCTURA VIAL CON CIVIL 3D 1
✅60.CURSO DISEÑO DE PISTAS Y VEREDAS CON CIVIL 3D
✅61.CURSO DISEÑO DE SISTEMA DE AGUA POTABLE Y ALCANTARILLADO SANITARIO
✅62.CURSO DISEÑÓ GEOMETRICO DE CARRETERAS
✅63.CURSO DISEÑO GEOMETRICO DE CARRETERAS CON CIVIL 3D 2
✅64.CURSO DISEÑO GEOMETRICO DE CARRETERAS CON EL ENFOQUE BIM EMPLEANDO CIVIL3D
✅65.CURSO DISEÑO Y ELABORACION DE PLANOS TOPOGRAFICOS
✅66.CURSO DRONES CON PIX4D
✅67.CURSO ELABORACION DE PLANOS DE LOTIZACION, SUBDIVISION Y PARCELACION CON CIVIL 3D.
✅68.CURSO ELABORACION DE PLANOS TOPOGRAFICOS CON CIVIL 3D
✅69.CURSO ELABORACION DE PLANOS TOPOGRAFICOS CON CIVIL 3D
✅70.CURSO ELABORACION MAPAS ARCGIS
✅71.CURSO ESPECIALISTA AUTOCAD CIVIL 3D 2022
✅72.CURSO ESPECIALISTA EN AUTOCAD CIVIL 3D
✅73.CURSO ESPECIALIZACION EN TOPOGRAFIA
✅74.CURSO ESPECIALIZADO MANEJO DE ESTACION TOTAL
✅75.CURSO EXPERTO EN ARCGIS BASICO INTERMEDIO ABANZADO
✅76.CURSO EXPERTO EN ARCGIS PRO (BASICO-INTERMEDIO-ABANZADO))
✅77.CURSO FOTOGRAMETRIA AGRICOLA
✅78.CURSO FOTOGRAMETRIA CON DRONE RTK-I
✅79.CURSO FOTOGRAMETRÍA CON DRONES 2
✅80.CURSO FOTOGRAMETRIA CON DRONES 1
✅81.CURSO FOTOGRAMETRIA CON DRONES 2021
✅82.CURSO FOTOGRAMETRIA Y TOPOGRAFIA CON DRONE EN MODO RTK
✅83.CURSO GEINCOR-CAPACITACION ESTACION TOTAL MARCA TOPCON MODELO OS-200
✅84.CURSO GEOESPACIAL-AUTOMATIZACION DE PLANOS DE LOTES CON ARCGIS
✅85.CURSO GEOMECÁNICA
✅86.CURSO GEOMINERA PERU -CURSO DE GPS DIFERENCIAL TRIMBLE
✅87.CURSO GEOPERSA - MASTER EN ARCGIS
✅88.CURSO GESTIÓN DE CATASTRO
✅89.CURSO GESTIÓN DE CATASTRO URBANO - COLEGIO DE INGENIEROS
✅90.CURSO GIS-CURSO ARCGIS PARA GEOLOGIA
✅91.CURSO GLOBAL MAPPER DESDE BASICO A EXPERTO
✅92.CURSO GOOGLE EARTH
✅93.CURSO GOOGLE EARTH ENGINE
✅94.CURSO GPS HL TARGET
✅95.CURSO GROUP GUEVARA- ELABORACION DE PLANOS DE UBICACION CON CIVIL 3D
✅96.CURSO GROUP GUEVARA-TOPOGRAFIA ELECTRONICA CON ESTACION TOTAL TOPCON Y LEICA
✅97.CURSO TELEDETECCION CON QGIS Y SAGA
✅98.CURSO HABILITACIONES URBANAS CON LANAZCA
✅99.CURSO IMÁGENES SATELITALES EN GOOGLE EARTH
✅100.CURSO SISTEMA GLOBAL DE NAVEGACION GNSS RTK
✅101.CURSO SISTEMAS DE INFORMACION GEOGRAFICA
✅102.CURSO TALLER DE POSICIONAMIENTO DE GNSS Y CERTIFICACION DE PUNTOS GEODESICOS
✅103.CURSO TECNICO EN TOPOGRAFIA
✅104.CURSO TELEDETECCION APLICADA A LA EXPLORACION MINERA CON ARCGIS
✅105.CURSO TELEDETECCIÓN CON ARCGIS
✅106.CURSO TELEDETECCIÓN CON R
✅107.CURSO TELEDETECCIÓN CON R Y RSCRIPT EN ()GIS INTERMEDIO
✅108.CURSO TELEDETECCIÓN GOOGLE EARTH ENGINE CON PYTHON
✅109.CURSO, VISORES Y MAPAS WEB CON ARCGIS MASTERGLS
✅110.DIPLOMADO EN CATASTRO Y SANEAMIENTO URBANO RURAL
✅111.DIPLOMADO EN TOPOGRAFIA
✅112.CURSO DISEÑO GEOMETRICO DE CARRETERAS CON CIVIL3D
✅113.CURSO REDES DE TUBERIA Y ALCANTARILLADO
✅114.CURSO SIG Y TELEDETECCIÓN APLICADA AL MONITOREO DE BOSQUES UTILIZANDO ARCGIS
✅115.CURSO TERRSET
✅116.CURSO INC-TOPOGRAFIA APLICADA A PROYECTOS DE INGENIERIA 2
✅117.CURSO ING-AJUSTES POLIGONALES DE ALTA PRECISION APLICADO A CARRETERAS
✅118.CURSO LEVANTAMIENTO TOPOGRAFICO CON DRONE
✅119.CURSO MANEJO DE DRON
✅120.CURSO MANEJO DE ESTACION TOTAL
✅121.CURSO MANEJO DE ESTACION TOTAL CON SIMULADOR
✅122.CURSO MANEJO DE ESTACION TOTAL Y CIVIL 3D
✅123.CURSO MANEJO DE GOOGLE HEART ORIENTADO A LA TOPOGRAFIA
✅124.CURSO MANEJO DE GPS DIFERENCIAL (PRACTICA)
✅125.CURSO MANEJO DE RECEPTORES GNSS Y CERTIFICACION DE PUNTOS GEODÉSICOS IGN
✅126.CURSO MANEJO Y FOTOGRAMETRIA CON DRONES
✅127.CURSO MASTER EN FOTOGRAMETRIA CONVENCIONAL
✅128.CURSO MASTER EN GOOGLE HEART PRO
✅129.CURSO MASTER GIS-CURSO DE AUTOCAD MAP 3D
✅130.CURSO MASTER SIG-CURSO ARCGIS PARA CATASTRO COMPLETO
✅131.CURSO MASTERGLS CATASTRO
✅132.CURSO MINESIGHT APLICADO A TOPOGRAFIA Y MODELAMIENTO SUPERFICIAL
✅133.CURSO MODELAMIENTO DE VIAS URBANAS CON CIVIL 3D
✅134.CURSO MODELOS DIGITALES DE ELEVACIONES (MDE) ANÁLISIS MORFOLÓGIOS Y SIG - UNIVERSIDAD DE BUENOS AIRES
✅135.CURSO NIVEL DE INGENIERO APLICADO A OBRAS DE INGENIERIA
✅136.CURSO PCI GEOMÁTICA IMÁGENES SATELITALES - GEOMÁTICA SOLUCIONES
✅137.CURSO PIX4DMAPPER SOFTWARE PARA FOTOGRAMETRÍA CON DRONE. RGB + MULTIESPECTRAL + TÉRMICO
✅138.CURSO PLANIMETRIA Y USO DE NIVEL TOPOGRAFICO
✅139.CURSO POSICIONAMIENTO GNSS Y CERTIFICACION DE PUNTOS GEODESICOS
✅140.CURSO PRACTICANDO CON ESTACION TOTAL
✅141.CURSO PRINCIPIOS DE TELEDETECCIÓN
✅142.CURSO PROCESAMIENTO DE DATOS TOPOGRÁFICOS
✅143.CURSO PROCESAMIENTO DE IMAGENES DE DRONES CON PIX4D
✅144.CURSO PROCESAMIENTO DE IMÁGENES SATELITALES CON PYTHON Y ()GIS
✅145.CURSO PROCESAMIENTO DE IMÁGENES SATELITALES EN GOOGLE EARTH ENGINE
✅146.CURSO PROCESAMIENTO DIGITAL DE IMAGENES DE AERONAVES PILOTADAS REMOTAMENTE (RPA)
✅147.CURSO PROCESAMIENTO LINEA DE BASE GNSS 2020
✅148.CURSO PROCESAMIENTO PPK-PHANTOM 4 RTK
✅149.CURSO PROCESAMIENTO+AJUSTE+COWERSION DE UTM A TOPOGRAFICA
✅150.CURSO PROCESO DE IMAGENES SATELITALES PARA ENVI
✅151.CURSO PROYECTOS DE SANEAMIENTO BASICO Y RIEGO CON CIVIL 3D
✅152.CURSO REDES GEODESICAS Y AJUSTE DE LINEA BASE
✅153.CURSO REDES TOPOGRAFICA Y GEODESICAS
✅154.CURSO SIG Y TELEDETECCIÓN APLICADO A MONITOREO DE BOSQUES UTILIZANDO R, GEE Y ()GIS - GEOMATICA
✅155.CURSO SISTEMA GLOBAL DE NAVEGACION
🥇+6 MEGA PACK DE PLANTILLAS CIVIL 3D (video y material)
📁PACK1-PLANTILLAS CIVIL 3D
📁PACK2-PLANTILLAS CIVIL 3D
📁PACK3-PLANTILLAS CIVIL 3D
📁PACK4-PLANTILLAS CIVIL 3D
📁PACK5-PLANTILLAS CIVIL 3D
📁PACK6-PLANTILLAS CIVIL 3D
🥇 INSTALADORES:
▶🆒GLOBAL MAPPER
▶🆒GOOGLE EART
▶🆒CIVIL 3D
▶🆒AUTOCAD
▶🆒TOPOCAL
▶🆒QGIS
▶🆒PYTON
▶🆒ARC GIS
▶🆒SAP2000
▶🆒CYPECAD
▶🆒PIX 4D
▶🆒gvSIG
➖➖➖➖➖➖➖
✅ precio por tiempo limitado
🚀¡Aprovecha Ahora!🚀
➖➖➖➖➖➖➖
𝑬𝑳 𝑴𝑨𝑻𝑬𝑹𝑰𝑨𝑳 𝑳𝑶 𝑬𝑵𝑽𝑰𝑨𝑴𝑶𝑺 𝑫𝑬 𝑰𝑵𝑴𝑬𝑫𝑰𝑨𝑻𝑶 𝒀 𝑬𝑳 𝑨𝑪𝑪𝑬𝑺𝑶 𝑬𝑺 𝑰𝑳𝑰𝑴𝑰𝑻𝑨𝑫𝑶. 👷‍♂️`,
    price: 50,
    originalPrice: 200,
    category: "Topografía",
    image: "/assets/topografia.jpg",
    rating: { rate: 4.9, count: 210 },
  },
];

const coursesWithSlugs = courses.map((course) => ({
  ...course,
  slug: slugify(course.title),
}));

export default coursesWithSlugs;
